import { DateTime } from 'luxon'

export const labraUIDateFormatForm = 'MMM dd, yyyy'

export const addOneDayToDate = (dateStr: string) =>
  DateTime.fromISO(dateStr).plus({ days: 1 }).toISODate()

export const addMonthsToDate = (dateStr: string, months: number) =>
  DateTime.fromISO(dateStr).plus({ months }).minus({ days: 1 }).toISODate()

export const calculateDurationInMonths = (
  containerOfferServiceLength: string | number | undefined,
  contractDurationTimeUnit?: string
): number => {
  if (!containerOfferServiceLength) {
    return 1
  }
  let durationInMonths: number
  if (contractDurationTimeUnit === 'YEARS') {
    durationInMonths =
      typeof containerOfferServiceLength === 'number'
        ? containerOfferServiceLength * 12
        : parseFloat(containerOfferServiceLength) * 12
  } else {
    durationInMonths =
      typeof containerOfferServiceLength === 'number'
        ? containerOfferServiceLength
        : parseFloat(containerOfferServiceLength)
  }
  return durationInMonths
}
